import fetch from 'isomorphic-fetch'
import { isEmpty } from 'lodash'
export const FETCH_STORE = 'FETCH_STORE'
export const FETCH_STORE_REJECTED = 'FETCH_STORE_REJECTED'
export const FETCH_STORE_FULFILLED = 'FETCH_STORE_FULFILLED'

export const SET_CURRENT_STORE = 'SET_CURRENT_STORE'
export const SET_CURRENT_FAQ = 'SET_CURRENT_FAQ'

export function fetchStore (storeId, fromServer = false, res) {
  return dispatch => {
    const url = fromServer ? 'https://api.homeretailgroup.com/storeinfo/v0/stores/' + storeId + '?apiKey=ff6r7umkc6sa3kjcg5enfakm' : '/stores/api/store/' + storeId
    return fetch(url)
      .then(response => {
        if (response.status >= 400) {
          res.statusCode = 404
          return
        }
        return response.json()
      })
      .then((newStore) => dispatch(retrieveStoreDetails(retrieveStore(newStore, null, storeId, res))))
  }
}

export function retrieveStore (store, additional = null, storeId, res = null) {
  if (res !== null) {
    if (isEmpty(store) || store.length > 500) { res.statusCode = 404; return false }
  }
  if (store.code === 0) { return null }
  return {
    id: String(storeId),
    name: store.legacy_name,
    type: _getStoreTypeFromBrand(store.brand),
    lat: parseFloat(store.location.longitude),
    lng: parseFloat(store.location.latitude),
    distance: additional === null ? null : parseFloat(additional.distance).toFixed(1),
    address: store.address_line[0],
    town: store.town,
    postcode: store.postcode,
    tel: store.phonebook[0].number,
    clickandcollect: _getClickAndCollect(store.locator_settings),
    clickAndCollectLocation: store.click_and_collect_location,
    alert: store.emergency_statement === '' || store.emergency_statement === undefined ? null : store.emergency_statement,
    canonical: `https://www.argos.co.uk${store.links[2].href}`,
    permalink: store.links[2].href,
    storeTimes: [{
      date: 'Sunday',
      time: store.timetable.defaultWeek.sunday[0].open + ' - ' + store.timetable.defaultWeek.sunday[0].close
    }, {
      date: 'Monday',
      time: store.timetable.defaultWeek.monday[0].open + ' - ' + store.timetable.defaultWeek.monday[0].close
    }, {
      date: 'Tuesday',
      time: store.timetable.defaultWeek.tuesday[0].open + ' - ' + store.timetable.defaultWeek.tuesday[0].close
    }, {
      date: 'Wednesday',
      time: store.timetable.defaultWeek.wednesday[0].open + ' - ' + store.timetable.defaultWeek.wednesday[0].close
    }, {
      date: 'Thursday',
      time: store.timetable.defaultWeek.thurstday[0].open + ' - ' + store.timetable.defaultWeek.thurstday[0].close
    }, {
      date: 'Friday',
      time: store.timetable.defaultWeek.friday[0].open + ' - ' + store.timetable.defaultWeek.friday[0].close
    }, {
      date: 'Saturday',
      time: store.timetable.defaultWeek.saturday[0].open + ' - ' + store.timetable.defaultWeek.saturday[0].close
    }]
  }
}

export function retrieveStoreDetails (store) {
  return {
    type: FETCH_STORE_FULFILLED,
    payload: {
      store: store,
      faqs: []
    }
  }
}

export function setCurrentStore (storeId, order) {
  return {
    type: SET_CURRENT_STORE,
    payload: {
      id: storeId,
      order: order
    }
  }
}

export function setCurrentFaq (faqId) {
  return {
    type: SET_CURRENT_FAQ,
    payload: faqId
  }
}

export function _getStoreTypeFromBrand (brand) {
  let storeType
  switch (brand) {
    case 'Sainsbury\'s':
      storeType = 1
      break
    case 'Habitat':
      storeType = 2
      break
    default:
      storeType = 0
      break
  }
  return storeType
}

export function _getClickAndCollect (settings) {
  return settings.storeprepay === 6
}



// WEBPACK FOOTER //
// ./src/actions/store.js